module.exports = (theArray = []) => {
    if (theArray.length > 0) {
        return theArray[0]
    }
    return null;
};



// WEBPACK FOOTER //
// ./app/lib/util/peak.js